import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { useT } from "@/i18n/useT";

export default function FaqPage() {
  const t = useT();
  const f = t.faq;
  const [open, setOpen] = useState(0);
  return (
    <div data-testid="faq-page" className="br-container py-20 md:py-28 max-w-3xl">
      <header className="mb-16 br-fade-in">
        <div className="br-eyebrow mb-4">{f.eyebrow}</div>
        <h1 className="font-serif text-4xl md:text-6xl text-espresso leading-tight">{f.title}</h1>
      </header>
      <div className="divide-y divide-walnut/20 border-y border-walnut/20">
        {f.items.map((item, i) => (
          <div key={i} data-testid={`faq-${i}`}>
            <button onClick={() => setOpen(open === i ? -1 : i)} className="w-full flex justify-between items-center py-6 text-left group">
              <span className="font-serif text-lg md:text-xl text-espresso group-hover:text-walnut transition-colors">{item.q}</span>
              <ChevronDown className={`w-4 h-4 text-walnut transition-transform duration-500 flex-shrink-0 ml-4 ${open === i ? "rotate-180" : ""}`} />
            </button>
            <div className={`overflow-hidden transition-all duration-500 ${open === i ? "max-h-96 pb-8" : "max-h-0"}`}>
              <p className="text-base font-light text-dark-walnut leading-relaxed">{item.a}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}